import { useEffect, useState } from "react";
import { Sprout, Wheat, Bird, Sun, Feather, Microscope, Landmark, Compass } from "lucide-react";
import { fetchAreas } from "@/lib/api";
import SectionHeader from "@/components/SectionHeader";

const ICONS = { Sprout, Wheat, Bird, Sun, Feather, Microscope, Landmark, Compass };

export default function AreasPage() {
  const [areas, setAreas] = useState([]);
  useEffect(() => { fetchAreas().then(setAreas).catch(() => {}); }, []);

  return (
    <div data-testid="page-areas" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
      <SectionHeader
        overline="Areas of focus"
        title={<>Our <span className="italic text-ra-ochre">focus</span>.</>}
        lede="Eight interconnected systems where Restoration Australia explores ideas, partnerships and practical solutions — from native seed and Caring for Country to climate adaptation, finance and regional capacity."
        testId="areas-header"
      />

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-ra-line border border-ra-line">
        {areas.map((a) => {
          const Icon = ICONS[a.icon] || Sprout;
          return (
            <article
              key={a.id}
              data-testid={`area-card-${a.slug}`}
              className="bg-ra-bone p-8 lg:p-12 hover:bg-ra-paper transition-colors duration-300 group"
            >
              <div className="flex items-start justify-between mb-6">
                <Icon size={36} className="text-ra-ochre" strokeWidth={1.3} />
                <div className="ra-serif text-5xl text-ra-light group-hover:text-ra-ochre transition-colors">0{a.order}</div>
              </div>
              <h2 className="ra-serif text-3xl lg:text-4xl leading-tight">{a.title}</h2>
              <p className="mt-3 italic text-ra-ochre">{a.summary}</p>
              <p className="mt-5 text-ra-soft leading-relaxed">{a.description}</p>
            </article>
          );
        })}
      </div>
    </div>
  );
}
